import useAuthService from "../session/useAuthService";

const http = {
    HEADERS: () => {
      return {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: "JWT fefege...",
      };
    },
    AUTH_HEADERS: () => {
      return {
        "Content-Type": "application/json",
        Accept: "*/*",
        Authorization: useAuthService.getToken(),
      };
    },
    MULTIPART_HEADERS: () => {
      return {
        "Content-Type": "multipart/form-data",
        Accept: "*/*",
        Authorization: "JWT fefege...",
      };
    },
    AUTH_MULTIPART_HEADERS: () => {
      return {
        "Content-Type": "multipart/form-data",
        Accept: "*/*",
        Authorization: useAuthService.getToken(),
      };
    },


  };
  
  export default http;